import { DialogBackdrop, DialogPanel, Dialog } from "@headlessui/react"
import cn from "../utils/cn"

const Modal = (props) => {
  const { isOpen, variant = "overlay", onClose, className, children } = props

  const doNothing = () => {} // Prevents the modal to close on backdrop click

  return (
    <Dialog
      as="div"
      className="relative z-50 focus:outline-none"
      open={isOpen}
      onClose={doNothing}
    >
      {variant === "full-screen" ? (
        <>
          <DialogBackdrop className="fixed inset-0 bg-black/30" />
          <div className="fixed inset-0 h-screen w-screen">
            <div className="py-1 px-3 flex justify-end bg-black/50">
              <span
                className="material-icons cursor-pointer p-2 text-white rounded-full"
                onClick={onClose}
              >
                close
              </span>
            </div>

            <DialogPanel
              transition
              className={cn(
                "bg-white h-full overflow-y-auto data-[closed]:transform-[scale(95%)] w-full pb-6 pt-4 rounded-t-xl duration-200 ease-out data-[closed]:opacity-0",
                className
              )}
            >
              <div className="px-6">{children}</div>
            </DialogPanel>
          </div>
        </>
      ) : (
        <>
          <DialogBackdrop className="fixed inset-0 bg-black/30" />
          <div className="fixed inset-0 w-screen overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4">
              <DialogPanel
                transition
                className={cn(
                  "data-[closed]:transform-[scale(95%)] w-full max-w-4xl rounded-xl bg-white pb-6 pt-4 duration-300 ease-out data-[closed]:opacity-0",
                  className
                )}
              >
                <div className="px-6">{children}</div>
              </DialogPanel>
            </div>
          </div>
        </>
      )}
    </Dialog>
  )
}

export default Modal
